import { render, staticRenderFns } from "./TwBenchmarkTable.vue?vue&type=template&id=6fdcbfc8&scoped=true"
import script from "./TwBenchmarkTable.vue?vue&type=script&lang=ts"
export * from "./TwBenchmarkTable.vue?vue&type=script&lang=ts"
import style0 from "./TwBenchmarkTable.vue?vue&type=style&index=0&id=6fdcbfc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdcbfc8",
  null
  
)

export default component.exports